import script from "./ResumeDL.vue?vue&type=script&lang=js"
export * from "./ResumeDL.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__